import {
  ALERTS_CLEAR,
  ALERTS_SUCCESS,
  ALERTS_ERROR,
  ALERTS_WARNING,
  ALERTS_INFO
} from "../types";

export const clearAlerts = () => ({
  type: ALERTS_CLEAR
});

export const showSuccessAlert = message => ({
  type: ALERTS_SUCCESS,
  message
});
export const showErrorAlert = message => ({
  type: ALERTS_ERROR,
  message
});
export const showWarningAlert = message => ({
  type: ALERTS_WARNING,
  message
});
export const showInfoAlert = message => ({
  type: ALERTS_INFO,
  message
});
